import axios from "axios";
import { del, get, post, put, patch } from "./permissions_api_helper";
import * as url from "./permissions_url_helper";




//======================= Get permissions
export const getPermissions = () => get(url.GET_PERMISSIONS);


// add permission
export const addNewPermission = permission => post(url.ADD_NEW_PERMISSION,  { permission: permission  });

// update permission
//export const updatePermission = permission => put(url.UPDATE_PERMISSION, permission);
export const updatePermission = permission => patch(`${url.UPDATE_PERMISSION}/${permission.uid}`,   { permission: permission  });


// delete permission
//export const deletePermission = permission => del(url.DELETE_PERMISSION, { headers: { permission } });
export const deletePermission = permission => del(`${url.DELETE_PERMISSION}/${permission}`);







export {
  //getLoggedInUser,
  
  
};
